import React, { useState } from "react";
import PropTypes from "prop-types";

import ApprovalFilters from "./ApprovalFilters";

import "./Approval.scss";

// const getApprovalType = new Map([
//   ["Manager", { from: "Completed", to: "Submitted" }],
//   ["CEO", { from: "Submitted", to: "Ready to Invoice" }],
//   [
//     "Invoice",
//     {
//       from: "Ready to Invoice",
//       to: "Invoiced"
//     }
//   ],
//   [
//     "Billing",
//     {
//       from: "Invoiced",
//       to: "Billed"
//     }
//   ]
// ]);
const Approval = ({ children, fetchData }) => {
  const [filters, setFilters] = useState({});

  const handleChange = (name) => (value) => {
    if (Array.isArray(value)) {
      setFilters((prev) => ({ ...prev, [name]: value.map((x) => x.value) }));
    } else {
      setFilters((prev) => ({ ...prev, [name]: value }));
    }
  };
  return (
    <div className="approval-page">
      <div className="approval-page-filters">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            fetchData(filters);
          }}
        >
          <ApprovalFilters onChange={handleChange}>
            <button type="submit" className="btn btn-submit">
              Fetch Data
            </button>
          </ApprovalFilters>
        </form>
      </div>
      <div className="approval-page-body content-wrapper">{children}</div>
    </div>
  );
};
Approval.propTypes = {
  fetchData: PropTypes.func,
  children: PropTypes.node
};
export default Approval;
